const handleScrollTop = (containerId: string) => {
  //'main-scroll-container'
  const mainContainer = document.getElementById(containerId);
  if (mainContainer && mainContainer.scrollTop > 20) {
    mainContainer.scrollTop = 0;
  }
};
export default handleScrollTop;
